import { router, usePage } from '@inertiajs/react'
import { Button } from '@radix-ui/themes'
import { signUpPath } from '@/shared/likes/signUpPath'

interface LikeData {
  id: number
}
interface LikeableData {
  id: number
}

interface Props {
  likeable: LikeableData
  /** Null when not liked — that's what the pages send. */
  like?: LikeData | null
  type: string
}

export default function LikeButton({ likeable, like, type }: Props) {
  const { props, url } = usePage()

  function handleDelete() {
    router.delete(`/likes/${like?.id}`)
  }

  function handleLike() {
    router.post(`/likes`, {
      likeable_type: type,
      likeable_id: likeable.id
    })
  }

  // A watch list needs an account. Sign-up is a Devise page, so a plain anchor.
  if (!props.currentUser) {
    return (
      <Button asChild>
        <a href={signUpPath(url)}>Add to Watch List</a>
      </Button>
    )
  }

  return like === null ?
    (<Button onClick={handleLike}>Add to Watch List</Button>)
    : (<Button onClick={handleDelete} color="gray">Remove from Watch List</Button>)

}
